var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYellowcard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "700pt",
    height: "700pt",
    viewBox: "0 0 700 700",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
    id: "v",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m14-0.84375c-0.73047 0.375-1.4844 0.65625-2.2656 0.84375-0.78125 0.19531-1.5938 0.29688-2.4375 0.29688-2.543 0-4.5547-0.70703-6.0312-2.125-1.4805-1.4141-2.2188-3.3359-2.2188-5.7656 0-2.4375 0.73828-4.3633 2.2188-5.7812 1.4766-1.4141 3.4883-2.125 6.0312-2.125 0.84375 0 1.6562 0.09375 2.4375 0.28125s1.5352 0.46875 2.2656 0.84375v3.1562c-0.73047-0.5-1.4492-0.86328-2.1562-1.0938-0.71094-0.22656-1.4531-0.34375-2.2344-0.34375-1.4062 0-2.5117 0.44922-3.3125 1.3438-0.80469 0.89844-1.2031 2.1367-1.2031 3.7188 0 1.5625 0.39844 2.7969 1.2031 3.7031 0.80078 0.89844 1.9062 1.3438 3.3125 1.3438 0.78125 0 1.5234-0.11328 2.2344-0.34375 0.70703-0.23828 1.4258-0.60156 2.1562-1.0938z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "c",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m10.234-8.3125c-0.3125-0.14453-0.63281-0.25391-0.95312-0.32812-0.3125-0.070313-0.63281-0.10938-0.95312-0.10938-0.9375 0-1.6641 0.30469-2.1719 0.90625-0.5 0.59375-0.75 1.4531-0.75 2.5781v5.2656h-3.6562v-11.422h3.6562v1.875c0.46875-0.75 1.0039-1.2969 1.6094-1.6406 0.61328-0.34375 1.3477-0.51562 2.2031-0.51562 0.11328 0 0.24219 0.007813 0.39062 0.015625 0.14453 0.011719 0.35156 0.03125 0.625 0.0625z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "a",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m13.156-5.75v1.0469h-8.5312c0.082031 0.85547 0.39062 1.5 0.92188 1.9375 0.53125 0.42969 1.2695 0.64062 2.2188 0.64062 0.76953 0 1.5547-0.11328 2.3594-0.34375 0.8125-0.22656 1.6445-0.57812 2.5-1.0469v2.8281c-0.86719 0.32422-1.7305 0.57031-2.5938 0.73438-0.86719 0.16406-1.7305 0.25-2.5938 0.25-2.0742 0-3.6836-0.52344-4.8281-1.5781-1.1484-1.0508-1.7188-2.5234-1.7188-4.4219 0-1.8633 0.5625-3.3281 1.6875-4.3906 1.1328-1.0703 2.6875-1.6094 4.6562-1.6094 1.7891 0 3.2227 0.54297 4.2969 1.625 1.082 1.0859 1.625 2.5273 1.625 4.3281zm-3.75-1.2031c0-0.69531-0.20312-1.2539-0.60938-1.6719-0.40625-0.42578-0.93359-0.64062-1.5781-0.64062-0.71094 0-1.2891 0.19922-1.7344 0.59375-0.4375 0.39844-0.71484 0.96875-0.82812 1.7188z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "f",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m6.875-5.1406c-0.76172 0-1.3359 0.13281-1.7188 0.39062-0.38672 0.26172-0.57812 0.64062-0.57812 1.1406 0 0.46094 0.15625 0.82422 0.46875 1.0938 0.3125 0.26172 0.73828 0.39062 1.2812 0.39062 0.6875 0 1.2656-0.24219 1.7344-0.73438 0.46875-0.5 0.70312-1.1172 0.70312-1.8594v-0.42188zm5.5781-1.375v6.5156h-3.6875v-1.6875c-0.49219 0.6875-1.043 1.1953-1.6562 1.5156-0.60547 0.3125-1.3438 0.46875-2.2188 0.46875-1.1875 0-2.1523-0.34375-2.8906-1.0312-0.74219-0.69531-1.1094-1.5938-1.1094-2.6875 0-1.3438 0.45703-2.3281 1.375-2.9531 0.92578-0.625 2.3789-0.9375 4.3594-0.9375h2.1406v-0.28125c0-0.58203-0.23047-1.0039-0.6875-1.2656-0.44922-0.26953-1.1562-0.40625-2.125-0.40625-0.78125 0-1.5117 0.078125-2.1875 0.23438-0.66797 0.15625-1.293 0.39062-1.875 0.70312v-2.7969c0.78906-0.1875 1.5781-0.32812 2.3594-0.42188 0.78906-0.10156 1.582-0.15625 2.375-0.15625 2.0508 0 3.5352 0.40625 4.4531 1.2188 0.91406 0.8125 1.375 2.1367 1.375 3.9688z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "b",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m5.75-14.672v3.25h3.75v2.6094h-3.75v4.8438c0 0.53125 0.10156 0.89062 0.3125 1.0781 0.20703 0.1875 0.625 0.28125 1.25 0.28125h1.875v2.6094h-3.125c-1.4492 0-2.4766-0.30078-3.0781-0.90625-0.59375-0.60156-0.89062-1.625-0.89062-3.0625v-4.8438h-1.8125v-2.6094h1.8125v-3.25z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "k",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m9.5312-9.75v-6.125h3.6719v15.875h-3.6719v-1.6562c-0.51172 0.67969-1.0703 1.1719-1.6719 1.4844-0.60547 0.3125-1.3047 0.46875-2.0938 0.46875-1.4062 0-2.5625-0.55469-3.4688-1.6719-0.90625-1.125-1.3594-2.5664-1.3594-4.3281 0-1.7578 0.45312-3.1953 1.3594-4.3125 0.90625-1.125 2.0625-1.6875 3.4688-1.6875 0.78906 0 1.4883 0.16406 2.0938 0.48438 0.60156 0.3125 1.1602 0.80469 1.6719 1.4688zm-2.4062 7.3906c0.78125 0 1.375-0.28125 1.7812-0.84375 0.41406-0.57031 0.625-1.4062 0.625-2.5 0-1.082-0.21094-1.9102-0.625-2.4844-0.40625-0.57031-1-0.85938-1.7812-0.85938s-1.3828 0.28906-1.7969 0.85938c-0.40625 0.57422-0.60938 1.4023-0.60938 2.4844 0 1.0938 0.20312 1.9297 0.60938 2.5 0.41406 0.5625 1.0156 0.84375 1.7969 0.84375z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "j",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m7.8281-2.3594c0.78125 0 1.375-0.28125 1.7812-0.84375 0.41406-0.57031 0.625-1.4062 0.625-2.5 0-1.082-0.21094-1.9102-0.625-2.4844-0.40625-0.57031-1-0.85938-1.7812-0.85938s-1.3828 0.28906-1.7969 0.85938c-0.41797 0.57422-0.625 1.4023-0.625 2.4844 0 1.0859 0.20703 1.9141 0.625 2.4844 0.41406 0.57422 1.0156 0.85938 1.7969 0.85938zm-2.4219-7.3906c0.5-0.66406 1.0547-1.1562 1.6719-1.4688 0.61328-0.32031 1.3164-0.48438 2.1094-0.48438 1.4062 0 2.5625 0.5625 3.4688 1.6875 0.90625 1.1172 1.3594 2.5547 1.3594 4.3125 0 1.7617-0.45312 3.2031-1.3594 4.3281-0.90625 1.1172-2.0625 1.6719-3.4688 1.6719-0.79297 0-1.4961-0.15625-2.1094-0.46875-0.61719-0.32031-1.1719-0.81641-1.6719-1.4844v1.6562h-3.6562v-15.875h3.6562z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "i",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.25-11.422h3.6562l3.0781 7.75 2.6094-7.75h3.6406l-4.7969 12.5c-0.48047 1.2695-1.043 2.1602-1.6875 2.6719-0.64844 0.50781-1.4961 0.76562-2.5469 0.76562h-2.1094v-2.4062h1.1406c0.61328 0 1.0625-0.10156 1.3438-0.29688 0.28906-0.19922 0.51562-0.55469 0.67188-1.0625l0.09375-0.3125z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "e",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m7.5-8.4844c0.82031 0 1.4102-0.14844 1.7656-0.45312 0.35156-0.30078 0.53125-0.80469 0.53125-1.5156 0-0.6875-0.17969-1.1797-0.53125-1.4844-0.35547-0.30078-0.94531-0.45312-1.7656-0.45312h-1.6562v3.9062zm-1.6562 2.7188v5.7656h-3.9219v-15.234h6c2 0 3.4688 0.33984 4.4062 1.0156 0.9375 0.67969 1.4062 1.7422 1.4062 3.1875 0 1.0117-0.24609 1.8398-0.73438 2.4844-0.49219 0.64844-1.2266 1.1211-2.2031 1.4219 0.53906 0.125 1.0234 0.40625 1.4531 0.84375 0.42578 0.42969 0.85156 1.0781 1.2812 1.9531l2.1406 4.3281h-4.1875l-1.8594-3.7812c-0.375-0.75781-0.75781-1.2812-1.1406-1.5625-0.375-0.28125-0.88672-0.42188-1.5312-0.42188z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "h",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.75-11.422h3.6562v11.422h-3.6562zm0-4.4531h3.6562v2.9844h-3.6562z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "g",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m9.2656-15.875v2.4062h-2.0156c-0.51172 0-0.87109 0.09375-1.0781 0.28125-0.21094 0.1875-0.3125 0.51172-0.3125 0.96875v0.79688h3.125v2.6094h-3.125v8.8125h-3.6406v-8.8125h-1.8281v-2.6094h1.8281v-0.79688c0-1.25 0.34375-2.1719 1.0312-2.7656 0.69531-0.59375 1.7734-0.89062 3.2344-0.89062z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "u",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m7.125-9.0469c-0.78125 0-1.3828 0.28906-1.7969 0.85938-0.40625 0.57422-0.60938 1.4023-0.60938 2.4844 0 1.0938 0.20312 1.9297 0.60938 2.5 0.41406 0.5625 1.0156 0.84375 1.7969 0.84375s1.375-0.28125 1.7812-0.84375c0.41406-0.57031 0.625-1.4062 0.625-2.5 0-1.082-0.21094-1.9102-0.625-2.4844-0.40625-0.57031-1-0.85938-1.7812-0.85938zm2.4062 7.3906c-0.51172 0.67969-1.0703 1.1719-1.6719 1.4844-0.60547 0.3125-1.3047 0.46875-2.0938 0.46875-1.4062 0-2.5625-0.55469-3.4688-1.6719-0.90625-1.125-1.3594-2.5664-1.3594-4.3281 0-1.7578 0.45312-3.1914 1.3594-4.2969 0.90625-1.1133 2.0625-1.6719 3.4688-1.6719 0.78906 0 1.4883 0.15625 2.0938 0.46875 0.60156 0.3125 1.1602 0.80469 1.6719 1.4688v-1.6875h3.6719v15.766h-3.6719z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "t",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.75-15.875h3.6562v15.875h-3.6562z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "d",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m7.1875-9.0938c-0.80469 0-1.418 0.29297-1.8438 0.875-0.42969 0.58594-0.64062 1.4219-0.64062 2.5156s0.21094 1.9336 0.64062 2.5156c0.42578 0.58594 1.0391 0.875 1.8438 0.875 0.80078 0 1.4102-0.28906 1.8281-0.875 0.42578-0.58203 0.64062-1.4219 0.64062-2.5156s-0.21484-1.9297-0.64062-2.5156c-0.41797-0.58203-1.0273-0.875-1.8281-0.875zm0-2.6094c1.9688 0 3.5039 0.53125 4.6094 1.5938 1.1016 1.0625 1.6562 2.5312 1.6562 4.4062s-0.55469 3.3438-1.6562 4.4062c-1.1055 1.0625-2.6406 1.5938-4.6094 1.5938s-3.5117-0.53125-4.625-1.5938c-1.1172-1.0625-1.6719-2.5312-1.6719-4.4062s0.55469-3.3438 1.6719-4.4062c1.1133-1.0625 2.6562-1.5938 4.625-1.5938z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "s",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m12.344-9.5312c0.45703-0.70703 1.0039-1.2422 1.6406-1.6094 0.63281-0.375 1.3359-0.5625 2.1094-0.5625 1.3125 0 2.3047 0.40625 2.9844 1.2188 0.6875 0.8125 1.0312 1.9922 1.0312 3.5312v6.9531h-3.6719v-5.9531c0.007812-0.09375 0.015625-0.1875 0.015625-0.28125 0.007813-0.09375 0.015625-0.22656 0.015625-0.40625 0-0.8125-0.12109-1.3984-0.35938-1.7656-0.24219-0.36328-0.625-0.54688-1.1562-0.54688-0.69922 0-1.2344 0.28906-1.6094 0.85938-0.375 0.57422-0.57031 1.4023-0.57812 2.4844v5.6094h-3.6719v-5.9531c0-1.2695-0.10938-2.0859-0.32812-2.4531-0.21875-0.36328-0.60938-0.54688-1.1719-0.54688-0.69922 0-1.2422 0.29297-1.625 0.875-0.375 0.57422-0.5625 1.3906-0.5625 2.4531v5.625h-3.6719v-11.422h3.6719v1.6719c0.44531-0.64453 0.96094-1.1289 1.5469-1.4531 0.58203-0.33203 1.2227-0.5 1.9219-0.5 0.78906 0 1.4883 0.19531 2.0938 0.57812 0.60156 0.375 1.0625 0.90625 1.375 1.5938z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "r",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m13.234-6.9531v6.9531h-3.6719v-5.2969c0-1-0.023438-1.6875-0.0625-2.0625-0.042969-0.375-0.12109-0.64844-0.23438-0.82812-0.13672-0.23828-0.32812-0.42578-0.57812-0.5625-0.24219-0.13281-0.51562-0.20312-0.82812-0.20312-0.76172 0-1.3594 0.29688-1.7969 0.89062-0.4375 0.58594-0.65625 1.3984-0.65625 2.4375v5.625h-3.6562v-15.875h3.6562v6.125c0.55078-0.66406 1.1328-1.1562 1.75-1.4688 0.625-0.32031 1.3125-0.48438 2.0625-0.48438 1.3125 0 2.3047 0.40625 2.9844 1.2188 0.6875 0.8125 1.0312 1.9922 1.0312 3.5312z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "q",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.9219-15.234h4.375l5.5469 10.453v-10.453h3.7188v15.234h-4.375l-5.5469-10.453v10.453h-3.7188z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "p",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.625-4.4531v-6.9688h3.6719v1.1406c0 0.61719-0.007813 1.3906-0.015625 2.3281v1.875c0 0.91797 0.019531 1.5781 0.0625 1.9844 0.050781 0.40625 0.13281 0.69922 0.25 0.875 0.15625 0.24219 0.35156 0.42969 0.59375 0.5625 0.23828 0.125 0.51562 0.1875 0.82812 0.1875 0.75781 0 1.3594-0.28906 1.7969-0.875 0.4375-0.58203 0.65625-1.3945 0.65625-2.4375v-5.6406h3.6562v11.422h-3.6562v-1.6562c-0.55469 0.66797-1.1367 1.1641-1.75 1.4844-0.61719 0.3125-1.293 0.46875-2.0312 0.46875-1.3242 0-2.3359-0.39844-3.0312-1.2031-0.6875-0.8125-1.0312-1.9922-1.0312-3.5469z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "o",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m13.234-6.9531v6.9531h-3.6719v-5.3281c0-0.97656-0.023438-1.6562-0.0625-2.0312-0.042969-0.375-0.12109-0.64844-0.23438-0.82812-0.13672-0.23828-0.32812-0.42578-0.57812-0.5625-0.24219-0.13281-0.51562-0.20312-0.82812-0.20312-0.76172 0-1.3594 0.29688-1.7969 0.89062-0.4375 0.58594-0.65625 1.3984-0.65625 2.4375v5.625h-3.6562v-11.422h3.6562v1.6719c0.55078-0.66406 1.1328-1.1562 1.75-1.4688 0.625-0.32031 1.3125-0.48438 2.0625-0.48438 1.3125 0 2.3047 0.40625 2.9844 1.2188 0.6875 0.8125 1.0312 1.9922 1.0312 3.5312z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "n",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.9219-15.234h6.5156c1.9375 0 3.4219 0.43359 4.4531 1.2969 1.0391 0.85547 1.5625 2.0781 1.5625 3.6719 0 1.6055-0.52344 2.8398-1.5625 3.7031-1.0312 0.85547-2.5156 1.2812-4.4531 1.2812h-2.5938v5.2812h-3.9219zm3.9219 2.8438v4.2656h2.1719c0.75781 0 1.3477-0.17969 1.7656-0.54688 0.41406-0.375 0.625-0.90625 0.625-1.5938 0-0.67578-0.21094-1.1953-0.625-1.5625-0.41797-0.375-1.0078-0.5625-1.7656-0.5625z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "m",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.75-11.422h3.6562v11.219c0 1.5312-0.37109 2.6953-1.1094 3.5-0.73047 0.8125-1.793 1.2188-3.1875 1.2188h-1.7969v-2.4062h0.625c0.69531 0 1.1719-0.15625 1.4219-0.46875 0.25781-0.3125 0.39062-0.92969 0.39062-1.8438zm0-4.4531h3.6562v2.9844h-3.6562z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "l",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m10.984-11.062v2.9688c-0.5-0.33203-1-0.58203-1.5-0.75-0.5-0.16406-1.0156-0.25-1.5469-0.25-1.0234 0-1.8203 0.30469-2.3906 0.90625-0.5625 0.59375-0.84375 1.4219-0.84375 2.4844 0 1.0742 0.28125 1.9062 0.84375 2.5 0.57031 0.59375 1.3672 0.89062 2.3906 0.89062 0.57031 0 1.1133-0.082031 1.625-0.25 0.50781-0.17578 0.98438-0.42969 1.4219-0.76562v2.9844c-0.57422 0.21875-1.1562 0.37891-1.75 0.48438-0.58594 0.10156-1.168 0.15625-1.75 0.15625-2.0625 0-3.6797-0.52344-4.8438-1.5781-1.168-1.0625-1.75-2.5352-1.75-4.4219 0-1.8828 0.58203-3.3516 1.75-4.4062 1.1641-1.0625 2.7812-1.5938 4.8438-1.5938 0.59375 0 1.1797 0.054687 1.7656 0.15625 0.58203 0.10547 1.1602 0.26562 1.7344 0.48438z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m328.81 418.18c8.5547 9.1562 36.828 40.375 52.426 68.988 3.7227 6.8281 6.7148 13.484 8.3984 19.613 1.3594 4.9414 1.9414 9.4297 0.85547 13.184-0.76563 2.6289-0.24219 5.4648 1.3984 7.6523 1.6484 2.1914 4.2266 3.4766 6.9609 3.4766h115.62c4.8047 0 8.7031-3.8945 8.7031-8.7031v-57.914c0-21.215 5.4023-42.07 15.695-60.617 0.003906-0.007813 0.007812-0.011719 0.011719-0.019531 24.078-43.371 12.141-97.887-27.867-127.22l-102.01-74.805v-149.19c0-14.637-11.863-26.5-26.5-26.5h-190.25c-14.637 0-26.496 11.863-26.496 26.496v339.06c0 14.637 11.859 26.5 26.496 26.5h136.54zm80.211-194.78v73.074l57.539 63.344c3.2305 3.5547 2.9688 9.0703-0.58984 12.301-3.5625 3.2305-9.0703 2.9688-12.301-0.58984l-63.832-70.277c-9.7148 17.648-24.195 28.484-43.629 32.246l39.168 71.805c1.4727 2.6953 1.4102 5.9688-0.16016 8.6133-1.5664 2.6406-4.4141 4.2617-7.4844 4.2617 0 0-25.508 0-25.5 0.003907 12.906 14.785 32.203 38.473 44.293 60.648 6.793 12.453 11.109 24.602 11.738 34.855h97.508v-49.207c0-24.168 6.1562-47.938 17.887-69.066 0.003906-0.007812 0.007813-0.015625 0.011719-0.019531 19.82-35.707 9.9922-80.582-22.938-104.73l-91.711-67.254zm-17.414 53.902v-224.68c0-5.0195-4.0664-9.0859-9.0859-9.0859h-190.25c-5.0156 0-9.0859 4.0664-9.0859 9.0859v339.06c0 5.0195 4.0703 9.0859 9.0859 9.0859h170.8l-47.273-86.672c-9.793-17.949-4.7773-40.375 11.73-52.449l0.007812-0.003906c17.035-12.457 40.723-10.055 54.91 5.5625zm-14.34 10.113-7.7227-8.5c-8.1992-9.0312-21.891-10.418-31.742-3.2188l-0.007813 0.007813c-9.457 6.918-12.332 19.766-6.7188 30.051l6.2461 11.453c18.902-1.9531 32.074-12.086 39.945-29.797z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("use", {
    x: 70,
    y: 622.6875,
    xlinkHref: "#v"
  }), /*#__PURE__*/React.createElement("use", {
    x: 85.335938,
    y: 622.6875,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("use", {
    x: 95.640625,
    y: 622.6875,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    x: 109.8125,
    y: 622.6875,
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("use", {
    x: 123.910156,
    y: 622.6875,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    x: 133.902344,
    y: 622.6875,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    x: 148.074219,
    y: 622.6875,
    xlinkHref: "#k"
  }), /*#__PURE__*/React.createElement("use", {
    x: 170.304688,
    y: 622.6875,
    xlinkHref: "#j"
  }), /*#__PURE__*/React.createElement("use", {
    x: 185.261719,
    y: 622.6875,
    xlinkHref: "#i"
  }), /*#__PURE__*/React.createElement("use", {
    x: 206.15625,
    y: 622.6875,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("use", {
    x: 222.246094,
    y: 622.6875,
    xlinkHref: "#h"
  }), /*#__PURE__*/React.createElement("use", {
    x: 229.410156,
    y: 622.6875,
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("use", {
    x: 238.5,
    y: 622.6875,
    xlinkHref: "#u"
  }), /*#__PURE__*/React.createElement("use", {
    x: 253.457031,
    y: 622.6875,
    xlinkHref: "#h"
  }), /*#__PURE__*/React.createElement("use", {
    x: 267.894531,
    y: 622.6875,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("use", {
    x: 283.984375,
    y: 622.6875,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    x: 298.15625,
    y: 622.6875,
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("use", {
    x: 312.257812,
    y: 622.6875,
    xlinkHref: "#t"
  }), /*#__PURE__*/React.createElement("use", {
    x: 70,
    y: 643.582031,
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("use", {
    x: 79.089844,
    y: 643.582031,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("use", {
    x: 89.394531,
    y: 643.582031,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("use", {
    x: 103.75,
    y: 643.582031,
    xlinkHref: "#s"
  }), /*#__PURE__*/React.createElement("use", {
    x: 132.796875,
    y: 643.582031,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    x: 142.789062,
    y: 643.582031,
    xlinkHref: "#r"
  }), /*#__PURE__*/React.createElement("use", {
    x: 157.664062,
    y: 643.582031,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    x: 179.109375,
    y: 643.582031,
    xlinkHref: "#q"
  }), /*#__PURE__*/React.createElement("use", {
    x: 196.597656,
    y: 643.582031,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("use", {
    x: 210.953125,
    y: 643.582031,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 225.828125,
    y: 643.582031,
    xlinkHref: "#o"
  }), /*#__PURE__*/React.createElement("use", {
    x: 247.980469,
    y: 643.582031,
    xlinkHref: "#n"
  }), /*#__PURE__*/React.createElement("use", {
    x: 263.292969,
    y: 643.582031,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("use", {
    x: 273.597656,
    y: 643.582031,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("use", {
    x: 287.953125,
    y: 643.582031,
    xlinkHref: "#m"
  }), /*#__PURE__*/React.createElement("use", {
    x: 295.117188,
    y: 643.582031,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    x: 309.289062,
    y: 643.582031,
    xlinkHref: "#l"
  }), /*#__PURE__*/React.createElement("use", {
    x: 321.675781,
    y: 643.582031,
    xlinkHref: "#b"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowcard);
export default __webpack_public_path__ + "static/media/yellowcard.71d6707a4397dcfb24574d1ce64c57c8.svg";
export { ForwardRef as ReactComponent };